module.exports = __webpack_public_path__ + "img/qilin-f-stage7-blink.170ac30b.png";